import React from "react";
import content from "../data/results/2024FitFestcontent.json";
import resultData from "../data/2024data.json";
import ResultsPage from "./ResultsPage";

const Results2024FitFest = () => <ResultsPage content={content} resultData={resultData} />;

export default Results2024FitFest;
